import { Component } from "@/types/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "formLinksWrapper"

export const presets = {}

export interface Props extends Component {}

export function FormLinksWrapper({ children, className, testId = COMPONENT_NAME }: Props) {
  return (
    <div className={cx(`flex justify-center gap-8 text-sm`, className)} data-test={testId}>
      {children}
    </div>
  )
}
